// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"719ecdb1","321":"1d53fcac","433":"a679f6bf","573":"6faa1bb6","830":"f2f777e1"}[chunkId] + ".chunk.js";
};